import { type Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "~/atoms/form";
import { Input } from "~/atoms/input";
import { Button } from "~/atoms/button";
import { Trash } from "lucide-react";
import {
  ControlledCombobox,
  type Option,
} from "~/molecules/ControlledCombobox";
import { type DocumentEditFormValues } from "~/hooks/useDocumentEditForm";

interface DocumentLinkFieldProps {
  name: "parentDocuments" | "childDocuments";
  title: string;
  options: Option[];
  control: Control<DocumentEditFormValues>;
}

export const DocumentLinkField = ({
  title,
  name,
  options,
  control,
}: DocumentLinkFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const documents = field.value ?? [];
        return (
          <FormItem>
            <FormLabel>{title}</FormLabel>
            {documents.map(({ value, label }) => (
              <div className="flex gap-3" key={value}>
                <Input value={label} readOnly />
                <Button
                  type="button"
                  onClick={() =>
                    field.onChange(documents.filter((c) => c.value !== value))
                  }
                  variant="ghost"
                  size="icon"
                >
                  <Trash />
                </Button>
              </div>
            ))}
            <FormControl>
              <ControlledCombobox
                value=""
                onChange={(value) => {
                  const opt = options.find((c) => c.value === value);
                  if (opt) field.onChange([...documents, opt]);
                }}
                placeholder={t("commons.customSelect.selectDocument")}
                options={options}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
